export const GET_NOTIFICATION = "admin/notifications";